import { Link } from 'react-router-dom';
import { CONSENT_KEY } from '../../components/ui/CookieConsent';

export default function Confidentialite() {
    return (
        <div className="legal-page">
            <div className="legal-inner">
                <h1>Politique de confidentialit&eacute;</h1>
                <p className="legal-updated">Derni&egrave;re mise &agrave; jour : juin 2026</p>

                <h2>1. Responsable du traitement</h2>
                <p>
                    Fabien Nicolet, entrepreneur individuel (EI)<br />
                    32 rue Camille Besan&ccedil;on, 25110 Baume-les-Dames, France<br />
                    Contact : <a href="mailto:contact@monquiz.fr">contact@monquiz.fr</a>
                </p>

                <h2>2. Donn&eacute;es collect&eacute;es</h2>
                <p>Nous collectons les donn&eacute;es suivantes :</p>
                <ul>
                    <li><strong>Inscription :</strong> adresse e-mail, pr&eacute;nom, mot de passe (hash&eacute;)</li>
                    <li><strong>Connexion Google (&laquo;&nbsp;Se connecter avec Google&nbsp;&raquo;) :</strong> si vous choisissez ce mode de connexion, Google nous transmet votre <strong>nom, pr&eacute;nom, photo de profil et adresse e-mail</strong>, &agrave; seule fin de cr&eacute;er ou d&rsquo;identifier votre compte monquiz.fr. Aucune autre donn&eacute;e de votre compte Google n&rsquo;est consult&eacute;e.</li>
                    <li><strong>Utilisation :</strong> r&eacute;ponses aux QCM, scores, progression, historique des sessions</li>
                    <li><strong>Paiement :</strong> identifiant client Stripe (aucune donn&eacute;e bancaire n&rsquo;est stock&eacute;e sur nos serveurs)</li>
                    <li><strong>Cookies analytiques :</strong> donn&eacute;es de navigation anonymis&eacute;es via Google Analytics (avec consentement)</li>
                    <li><strong>Quiz publics (codes &amp; campagnes &laquo;&nbsp;Open&nbsp;&raquo;) :</strong> mesure d&rsquo;audience anonyme &mdash; identifiant de session al&eacute;atoire, progression et r&eacute;sultat, source de provenance (UTM, site r&eacute;f&eacute;rent) et type d&rsquo;appareil. Aucun compte ni donn&eacute;e personnelle n&rsquo;est requis ou stock&eacute;.</li>
                    <li><strong>Ma Th&eacute;matique (g&eacute;n&eacute;ration par IA) :</strong> les documents que vous importez et les instructions associ&eacute;es sont transmis &agrave; notre prestataire d&rsquo;IA (Google &mdash; API Gemini) &agrave; seule fin de g&eacute;n&eacute;rer des questions. Ils ne sont pas utilis&eacute;s &agrave; d&rsquo;autres fins.</li>
                </ul>
                <p>
                    Les quiz accessibles publiquement par <strong>code</strong> ou via nos <strong>campagnes &laquo;&nbsp;Open&nbsp;&raquo;</strong>
                    {' '}(publi&eacute;es sur les r&eacute;seaux sociaux) peuvent &ecirc;tre jou&eacute;s sans inscription. Pour mesurer leur
                    audience et am&eacute;liorer nos contenus, nous enregistrons des informations <strong>strictement anonymes</strong> :
                    un identifiant de session g&eacute;n&eacute;r&eacute; al&eacute;atoirement (sans lien avec une personne), l&rsquo;avancement
                    et le score, la source de provenance (param&egrave;tres UTM du lien, site r&eacute;f&eacute;rent) et le type d&rsquo;appareil
                    (mobile / ordinateur). Ces donn&eacute;es ne contiennent <strong>ni nom, ni e-mail, ni adresse IP</strong> et ne
                    permettent pas de vous r&eacute;identifier. Ce traitement repose sur notre int&eacute;r&ecirc;t l&eacute;gitime &agrave;
                    mesurer l&rsquo;efficacit&eacute; de nos publications et la qualit&eacute; de nos questions.
                </p>

                <h2>3. Finalit&eacute;s du traitement</h2>
                <ul>
                    <li>Gestion de votre compte et authentification</li>
                    <li>Fourniture du service (QCM, suivi de progression, historique)</li>
                    <li>Gestion des abonnements et paiements</li>
                    <li>Am&eacute;lioration du service (statistiques d&rsquo;usage anonymis&eacute;es)</li>
                    <li>Communication li&eacute;e au service (expiration d&rsquo;abonnement, mises &agrave; jour)</li>
                </ul>

                <h2>4. Base l&eacute;gale</h2>
                <ul>
                    <li><strong>Ex&eacute;cution du contrat :</strong> donn&eacute;es de compte, r&eacute;ponses QCM, paiement</li>
                    <li><strong>Consentement :</strong> cookies analytiques, communications marketing</li>
                    <li><strong>Int&eacute;r&ecirc;t l&eacute;gitime :</strong> s&eacute;curit&eacute; du service, pr&eacute;vention des fraudes, mesure d&rsquo;audience anonyme des quiz publics</li>
                </ul>

                <h2>5. Dur&eacute;e de conservation</h2>
                <ul>
                    <li><strong>Donn&eacute;es de compte :</strong> conserv&eacute;es tant que le compte est actif, puis 3 ans apr&egrave;s la derni&egrave;re connexion</li>
                    <li><strong>Donn&eacute;es de paiement :</strong> conserv&eacute;es conform&eacute;ment aux obligations comptables (10 ans)</li>
                    <li><strong>Cookies analytiques :</strong> 13 mois maximum</li>
                    <li><strong>Mesures d&rsquo;audience des quiz publics :</strong> conserv&eacute;es sous forme anonyme &agrave; des fins statistiques</li>
                </ul>

                <h2>6. Destinataires des donn&eacute;es</h2>
                <p>Vos donn&eacute;es sont trait&eacute;es par :</p>
                <ul>
                    <li><strong>Stripe</strong> (paiement) &mdash; certifi&eacute; PCI-DSS</li>
                    <li><strong>o2switch</strong> (h&eacute;bergement) &mdash; serveurs en France</li>
                    <li><strong>Google Analytics</strong> (analyse, avec consentement) &mdash; donn&eacute;es anonymis&eacute;es</li>
                    <li><strong>Google &mdash; API Gemini</strong> (g&eacute;n&eacute;ration de QCM du service &laquo;&nbsp;Ma Th&eacute;matique&nbsp;&raquo;) &mdash; traite les documents que vous importez, uniquement pour produire les questions</li>
                </ul>
                <p>Aucune donn&eacute;e n&rsquo;est vendue &agrave; des tiers.</p>
                <p>
                    <strong>Th&eacute;matiques partag&eacute;es :</strong> si vous acc&eacute;dez &agrave; une th&eacute;matique
                    via un <strong>code de partage</strong>, le propri&eacute;taire de cette th&eacute;matique peut consulter
                    votre progression et vos r&eacute;sultats sur celle-ci, ainsi que, le cas &eacute;ch&eacute;ant, le nom
                    ou l&rsquo;e-mail que vous fournissez. R&eacute;ciproquement, si vous distribuez des codes de partage,
                    vous &ecirc;tes responsable d&rsquo;informer les personnes que vous invitez et de recueillir leur consentement.
                </p>

                <h2>7. Transferts hors UE</h2>
                <p>
                    Les donn&eacute;es de paiement trait&eacute;es par Stripe, les donn&eacute;es
                    analytiques et les documents trait&eacute;s pour la g&eacute;n&eacute;ration de questions
                    (Google &mdash; Analytics et API Gemini) peuvent &ecirc;tre transf&eacute;r&eacute;s
                    aux &Eacute;tats-Unis dans le cadre du EU-US Data Privacy Framework.
                </p>

                <h2>8. Vos droits</h2>
                <p>Conform&eacute;ment au RGPD, vous disposez des droits suivants :</p>
                <ul>
                    <li>Droit d&rsquo;acc&egrave;s &agrave; vos donn&eacute;es</li>
                    <li>Droit de rectification</li>
                    <li>Droit &agrave; l&rsquo;effacement (&laquo;&nbsp;droit &agrave; l&rsquo;oubli&nbsp;&raquo;)</li>
                    <li>Droit &agrave; la portabilit&eacute;</li>
                    <li>Droit d&rsquo;opposition et de limitation du traitement</li>
                    <li>Droit de retirer votre consentement (cookies analytiques)</li>
                </ul>
                <p>
                    <strong>Suppression de compte en self-service :</strong> vous pouvez supprimer
                    d&eacute;finitivement votre compte &agrave; tout moment depuis votre espace personnel,
                    rubrique <Link to="/compte/account/infos">&laquo;&nbsp;Mes infos&nbsp;&raquo;</Link> &rarr; section
                    &laquo;&nbsp;Zone de danger&nbsp;&raquo;. Toutes vos donn&eacute;es personnelles
                    (pr&eacute;nom, e-mail, mot de passe, pr&eacute;f&eacute;rences, historique personnel) sont
                    effac&eacute;es imm&eacute;diatement. Les statistiques de quiz peuvent &ecirc;tre conserv&eacute;es
                    sous forme anonymis&eacute;e, sans aucun lien possible avec votre identit&eacute;.
                </p>
                <p>
                    Pour exercer vos autres droits, contactez-nous &agrave;{' '}
                    <a href="mailto:contact@monquiz.fr">contact@monquiz.fr</a>.
                    Nous r&eacute;pondrons dans un d&eacute;lai d&rsquo;un mois.
                </p>
                <p>
                    Vous pouvez &eacute;galement introduire une r&eacute;clamation aupr&egrave;s de la
                    CNIL : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>.
                </p>

                <h2>9. S&eacute;curit&eacute;</h2>
                <p>
                    Nous mettons en &oelig;uvre des mesures techniques et organisationnelles pour
                    prot&eacute;ger vos donn&eacute;es : chiffrement des mots de passe (bcrypt),
                    connexion HTTPS, tokens JWT &agrave; dur&eacute;e limit&eacute;e, acc&egrave;s
                    restreint aux donn&eacute;es.
                </p>

                <h2>10. Cookies</h2>
                <table className="legal-table">
                    <thead>
                        <tr>
                            <th>Cookie</th>
                            <th>Finalit&eacute;</th>
                            <th>Dur&eacute;e</th>
                            <th>Consentement</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>JWT (localStorage)</td>
                            <td>Authentification</td>
                            <td>Session</td>
                            <td>N&eacute;cessaire</td>
                        </tr>
                        <tr>
                            <td>cookie_consent</td>
                            <td>M&eacute;moriser le choix cookies</td>
                            <td>12 mois</td>
                            <td>N&eacute;cessaire</td>
                        </tr>
                        <tr>
                            <td>Google Analytics (_ga, _gid)</td>
                            <td>Statistiques de visite</td>
                            <td>13 mois</td>
                            <td>Requis</td>
                        </tr>
                    </tbody>
                </table>

                <div className="cookie-manage-block">
                    <p>Pour modifier votre choix, cliquez sur le bouton ci-dessous. La bannière réapparaîtra et vous pourrez accepter ou refuser les cookies analytiques.</p>
                    <button
                        className="btn btn-outline btn-sm"
                        onClick={() => {
                            localStorage.removeItem(CONSENT_KEY);
                            window.location.reload();
                        }}
                    >
                        Gérer mes préférences cookies
                    </button>
                </div>

                <h2>11. Modifications</h2>
                <p>
                    Cette politique peut &ecirc;tre mise &agrave; jour. En cas de modification
                    substantielle, les utilisateurs inscrits en seront inform&eacute;s par e-mail.
                </p>

                <div className="legal-footer">
                    <Link to="/">&larr; Retour &agrave; l&rsquo;accueil</Link>
                </div>
            </div>
        </div>
    );
}
